/* eslint-disable react/no-multi-comp */
import React, { Component } from "react";
import { Container, Header, Item } from "semantic-ui-react";
import ExternalLink from "./components/ExternalLink";
import MurrahLighting from "./assets/MurrahLighting.pdf";
import MurrahEquipment from "./assets/MurrahHallTechEquipmentList.pdf";
import Email from "./components/Email";
import PropTypes from "prop-types";
import Pagelayout from "./components/Pagelayout";
import { cloudinaryHallImages } from "./photoMetaInfo";

class PriceTable extends Component {
  render() {
    return (
      <table style={{ marginBottom: "1rem", borderSpacing: "0px" }}>
        {this.props.children}
      </table>
    );
  }
}
PriceTable.propTypes = {
  children: PropTypes.node,
};

class PriceTableHeading extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th colSpan="2" style={{ textAlign: "left" }}>
            <strong>{this.props.children}</strong>
          </th>
        </tr>
      </thead>
    );
  }
}
PriceTableHeading.propTypes = {
  children: PropTypes.node,
};

class PriceTableBody extends Component {
  render() {
    return <tbody>{this.props.children}</tbody>;
  }
}
PriceTableBody.propTypes = {
  children: PropTypes.node,
};

class PriceTableEntry extends Component {
  render() {
    return (
      <tr>
        <td width={400}>
          {this.props.desc}
          {this.props.children}
        </td>
        <td style={{ verticalAlign: "top" }}>{this.props.price}</td>
      </tr>
    );
  }
}
PriceTableEntry.propTypes = {
  desc: PropTypes.string,
  price: PropTypes.string,
  children: PropTypes.node,
};

export default class Hiring extends Component {
  renderHiringText() {
    return (
      <div>
        <p>
          <strong>
            The Murrah Hall is a Bega Valley Shire Council owned community hall,
            staffed and run by a committee of volunteers.
          </strong>
        </p>

        <Header as="h2">For all Hall bookings and enquiries contact:</Header>
        <p>
          Mary McLean, Bookings Officer
          <br />
          Ph: 0428 698 150
          <br />
          Email: <Email />
        </p>
        <p>
          Post: Murrah Hall Committee
          <br />
          PO Box 191
          <br />
          Bermagui, NSW, 2546
        </p>

        <Header as="h3">All Social and Community Bookings</Header>
        <p>Contact Murrah Hall Booking Officer</p>

        <Header as="h3">Rehearsal and Theatre Performance Bookings</Header>
        <p>Contact Murrah Hall Booking Officer</p>

        <Header as="h2">For Profit Hall and Surrounds Bookings</Header>
        <p>
          Professional Hirers must show PDF evidence of their own 3rd Party
          Public Liability Insurance before the hire date is confirmed.
        </p>
        <p>
          <strong>Fees &amp; Charges</strong>: to be paid directly to Murrah
          Hall Committee on the day of the event. An official BVSC receipt will
          be issued.
        </p>
        <p>
          Cancellation of a booking due to health, weather or associated
          conditions will not incur a penalty payment.
        </p>

        <Header as="h2">Venue Hire Requirements</Header>
        <ul>
          <li>
            All music/social event inquiries are subject to discussion with the
            hirer prior to a booking confirmation.
          </li>
          <li>
            The Committee encourages free admission for children under 16 y.o.
            and a HCC concession policy where possible.
          </li>
          <li>Daytime music events are ‘all ages and inclusive’.</li>
          <li>
            For day/night shows: Assistance with clean-up as well as cleaning
            fee.
          </li>
          <li>
            Breakages or damages resulting from audience behaviour will be
            costed and promptly paid for by the hirer. (Social hires pay a
            refundable bond.)
          </li>
        </ul>

        <Header as="h2">Venue Essentials</Header>
        <p>
          <strong>Capacity Indoors:</strong> Seated audience numbers are between
          85 (seats) – 120 (inc. side benches). Adjacent space between hall and
          BBQ/Cantina allows for greater circulating numbers in an inclusive
          experience.
        </p>
        <p>
          <strong>Capacity Outdoors:</strong> Murrah Amphitheatre: 250 (seated)
        </p>

        <Header as="h2">Venue Facilities</Header>

        <Header as="h3">Hall Indoors</Header>
        <ul>
          <li>
            Acoustically tuned hall space featuring safe, clean, reverb-free
            sound
          </li>
          <li>100% lighting coverage</li>
          <li>
            Seated audience 80 (seats) – 120 (inc. side &amp; rear benches)
          </li>
          <li>
            Low stage 450 mm high X 5400 mm (wide) X 2900 mm (deep) X 3200 mm
            (high)
          </li>
          <li>
            Large onstage pull down screen for presentations (no projector)
          </li>
          <li>
            A secure dressing room with onstage/rear of hall access
          </li>
          <li>
            Dance music events use outdoor chair placement for a circulating
            audience of up to 250
          </li>
          <li>80 stackable chairs</li>
          <li>6 large tables &amp; assorted smaller ones</li>
          <li>
            Semi-commercial equipped kitchen with mugs, cutlery, crockery,
            commercial pots, saucepans &amp; equipment
          </li>
          <li>Commercial urn</li>
        </ul>

        <Header as="h3">Outdoors</Header>
        <ul>
          <li>
            250 seat outdoor amphitheatre with power, sound &amp; lighting
            outlets
          </li>
          <li>
            16 portable staging units, safety railings &amp; stairs plus older
            additional units (contact: <Email />)
          </li>
          <li>Stackable chairs</li>
          <li>
            Outdoor BBQ/Cantina servery (BBQ plate, fridge, benches)
          </li>
          <li>
            Large onsite car park with more parking nearby
          </li>
          <li>Disabled access: hall ramp and toilet</li>
          <li>Floodlights – car park</li>
          <li>Mobile phone reception</li>
        </ul>

        <p>
          <strong>Professional Hirers must show evidence of their own Public Liability
          Insurance before the hire date is confirmed.</strong>
        </p>
        <p>
          <strong>All door takings revert to the hirer.</strong>
        </p>
        <p>
          <strong>The Murrah Hall has no liquor licence.</strong>
        </p>

        <Header as="h2">For Profit Hall Hire Rates</Header>
        <PriceTable>
          <PriceTableBody>
            <PriceTableEntry
              desc="Monday to Thursday (day & night inclusive):"
              price="$90"
            />
            <PriceTableEntry
              desc="Friday or Saturday Night:"
              price="$150"
            />
            <PriceTableEntry
              desc="Saturday Afternoon to Evening:"
              price="$200"
            />
            <PriceTableEntry
              desc="Saturday or Sunday Afternoon:"
              price="$90"
            />
          </PriceTableBody>
        </PriceTable>

        <Header as="h2">Additional Hall Hire Fees and Charges</Header>

        <Header as="h3">All Hirers</Header>
          Hall and Supper Room gas heating: $5.00 per hour (if used)

        <Header as="h3">Professional Hirers only</Header>
        Cleaning and clean up fee: $50

        <Header as="h2">Equipment Hire – onsite only</Header>

        <PriceTable>
          <PriceTableHeading>Audio</PriceTableHeading>
          <PriceTableBody>
            <PriceTableEntry desc="Full portable PA" price="$200" />
            <PriceTableEntry>
              PA hire is only allowed with the use of our local operators<br />
              <strong>No 3rd party.</strong>
            </PriceTableEntry>
            <PriceTableEntry>
              Payment of local operators is the hirer’s responsibility
            </PriceTableEntry>
            <PriceTableEntry desc="Small portable PA" price="$150" />
            <PriceTableEntry>
              <ExternalLink href={MurrahEquipment}>
                Murrah hall equipment list
              </ExternalLink>
            </PriceTableEntry>
          </PriceTableBody>
        </PriceTable>

        <PriceTable>
          <PriceTableHeading>Lighting</PriceTableHeading>
          <PriceTableBody>
            <PriceTableEntry price="$100">
              Full system with our operator:
            </PriceTableEntry>
            <PriceTableEntry
              desc="Full system with your operator or set state:"
              price="$50"
            />
            <PriceTableEntry>
              <ExternalLink href={MurrahLighting}>Lighting layout</ExternalLink>
            </PriceTableEntry>
          </PriceTableBody>
        </PriceTable>

        <PriceTable>
          <PriceTableBody>
            <PriceTableEntry
              desc="Portable Rostra per unit"
              price="$20"
            />
          </PriceTableBody>
        </PriceTable>

        <p>
          <strong>
            For more technical details, specs and shapes: <Email />
          </strong>
        </p>

        <Header as="h2">Murrah Artist Support</Header>

        <Header as="h3">Marketing at no professional hirer cost</Header>
        <ul>
          <li>
            Murrah Hall Facebook page plus 5 regional email lists, Murrah Hall
            webpage
          </li>
          <li>
            Poster placement: (25 × A3 &amp; 10 × A4) — you provide posters
          </li>
          <li>Provide local media contact list</li>
          <li>
            Merchandising: Supper Room space available with tables
          </li>
        </ul>

        <Header as="h3">Murrah Hall Venue Support for Artists</Header>
        <ul>
          <li>Free meals and snacks</li>
          <li>Free access to teas and insto coffee</li>
          <li>Private dressing room with fridge and multiple power outlets</li>
          <li>Unfortunately, no shower available</li>
        </ul>

      </div>
    );
  }

  render() {
    return (
      <Pagelayout activeItem="hiring">
        <Container text>
          <Header as="h1">Hall Hire at the Murrah</Header>
          <Item.Group>
            <Item>
              <Item.Content>{this.renderHiringText()}</Item.Content>

              <Item.Image
                style={{
                  marginLeft: "2rem",
                  marginTop: "-1rem",
                }}
              >
                <div className="ui one column grid">
                  <div className="tablet computer only column">
                    {cloudinaryHallImages}
                  </div>
                </div>
              </Item.Image>
            </Item>
          </Item.Group>

          <div className="ui two column grid container">
            {cloudinaryHallImages.map((poster, index) => (
              <div className="mobile only column" key={index}>
                {poster}
              </div>
            ))}
          </div>
        </Container>
      </Pagelayout>
    );
  }
}
